import React from 'react';
import { motion } from 'framer-motion';
import { Building } from 'lucide-react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import PageHeader from '../../components/UI/PageHeader';
import MerchantSpreadsheet from '../../components/Merchants/MerchantSpreadsheet';

const StaffMerchantRecords = () => {
  return (
    <DashboardLayout userRole="staff">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="space-y-8"
      >
        <PageHeader
          title="Merchant Records"
          subtitle="Manage merchant information and daily transaction records"
          icon={Building}
        />
        
        <MerchantSpreadsheet userRole="staff" />
      </motion.div>
    </DashboardLayout>
  );
};

export default StaffMerchantRecords;